import styled from '@emotion/styled'
import {
  Text,
  Panel,
  IconFACheck,
  IconFATimes,
  Spinner
} from 'mailup-web-components'

export const IconWrapper = styled.span`
  font-size: ${({ fontSize }) => fontSize || '43px'};
  color: ${({ color }) => color || 'var(--silver)'};
`

export const StyledText = styled(Text)`
  font-size: 28px !important;
`

export const StyledPanel = styled(Panel)`
  ${({ filtered }) => filtered && 'border: 3px solid var(--java) !important;'}
`

const iconStyle = `font-size: 14px;
width: 21px;
height: 21px;
border-radius: 50%;
font-size: 14px;
width: 21px;
height: 21px;
border-radius: 50%;

> svg {
  top: calc(50% + 1px) !important;
  left: 50%;
  transform: translate(-50%, -50%);
}
`

export const IconOK = styled(IconFACheck)`
  ${iconStyle}
  color: #56b113;
  background-color: #c4e8ae;
  > svg {
    width: 12px !important;
    height: 9px !important;
  }
`

export const IconKO = styled(IconFATimes)`
  ${iconStyle}
  color: #fd4541;
  background-color: #ffafa7;
  > svg {
    width: 8px !important;
    height: 8px !important;
  }
`

export const StyledSpinner = styled(Spinner)`
  align-self: top;
  font-size: 28px;
`
